import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { Questionnaire } from "../../interfaces/questionnaire";

@Component({
  selector: "app-questionnaires-item",
  templateUrl: "./questionnaires-item.component.html",
  styleUrls: ["./questionnaires-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionnaireItemComponent {
  @Input() questionnaire: Questionnaire;
  @Output()
  itemClicked: EventEmitter<Questionnaire> = new EventEmitter<Questionnaire>();
  @Output()
  deleteClicked: EventEmitter<Questionnaire> = new EventEmitter<Questionnaire>();
  @Output()
  sendClicked: EventEmitter<Questionnaire> = new EventEmitter<Questionnaire>();

  constructor() {}

  itemCardClicked() {
    this.itemClicked.emit(this.questionnaire);
  }

  itemDeleteClicked() {
    this.deleteClicked.emit(this.questionnaire);
  }

  itemSendClicked() {
    this.sendClicked.emit(this.questionnaire);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/questionnaires-item/questionnaires-item.component.ts